/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AddressesDto } from '../models/addresses-dto';
import { apiOrderOrdersGet } from '../fn/orders/api-order-orders-get';
import { ApiOrderOrdersGet$Params } from '../fn/orders/api-order-orders-get';
import { apiOrderOrdersGet$Plain } from '../fn/orders/api-order-orders-get-plain';
import { ApiOrderOrdersGet$Plain$Params } from '../fn/orders/api-order-orders-get-plain';
import { apiOrderOrdersOrderIdCheckstatusPut } from '../fn/orders/api-order-orders-order-id-checkstatus-put';
import { ApiOrderOrdersOrderIdCheckstatusPut$Params } from '../fn/orders/api-order-orders-order-id-checkstatus-put';
import { apiOrderOrdersOrderIdCheckstatusPut$Plain } from '../fn/orders/api-order-orders-order-id-checkstatus-put-plain';
import { ApiOrderOrdersOrderIdCheckstatusPut$Plain$Params } from '../fn/orders/api-order-orders-order-id-checkstatus-put-plain';
import { apiOrderOrdersOrderIdGet } from '../fn/orders/api-order-orders-order-id-get';
import { ApiOrderOrdersOrderIdGet$Params } from '../fn/orders/api-order-orders-order-id-get';
import { apiOrderOrdersOrderIdGet$Plain } from '../fn/orders/api-order-orders-order-id-get-plain';
import { ApiOrderOrdersOrderIdGet$Plain$Params } from '../fn/orders/api-order-orders-order-id-get-plain';
import { apiOrderOrdersStoredaddressesGet } from '../fn/orders/api-order-orders-storedaddresses-get';
import { ApiOrderOrdersStoredaddressesGet$Params } from '../fn/orders/api-order-orders-storedaddresses-get';
import { apiOrderOrdersStoredaddressesGet$Plain } from '../fn/orders/api-order-orders-storedaddresses-get-plain';
import { ApiOrderOrdersStoredaddressesGet$Plain$Params } from '../fn/orders/api-order-orders-storedaddresses-get-plain';
import { Order } from '../models/order';
import { Response } from '../models/response';

@Injectable({ providedIn: 'root' })
export class OrdersService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiOrderOrdersStoredaddressesGet()` */
  static readonly ApiOrderOrdersStoredaddressesGetPath = '/api/order/orders/storedaddresses';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiOrderOrdersStoredaddressesGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiOrderOrdersStoredaddressesGet$Plain$Response(params?: ApiOrderOrdersStoredaddressesGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AddressesDto>> {
    return apiOrderOrdersStoredaddressesGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiOrderOrdersStoredaddressesGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiOrderOrdersStoredaddressesGet$Plain(params?: ApiOrderOrdersStoredaddressesGet$Plain$Params, context?: HttpContext): Observable<AddressesDto> {
    return this.apiOrderOrdersStoredaddressesGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<AddressesDto>): AddressesDto => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiOrderOrdersStoredaddressesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiOrderOrdersStoredaddressesGet$Response(params?: ApiOrderOrdersStoredaddressesGet$Params, context?: HttpContext): Observable<StrictHttpResponse<AddressesDto>> {
    return apiOrderOrdersStoredaddressesGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiOrderOrdersStoredaddressesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiOrderOrdersStoredaddressesGet(params?: ApiOrderOrdersStoredaddressesGet$Params, context?: HttpContext): Observable<AddressesDto> {
    return this.apiOrderOrdersStoredaddressesGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<AddressesDto>): AddressesDto => r.body)
    );
  }

  /** Path part for operation `apiOrderOrdersOrderIdGet()` */
  static readonly ApiOrderOrdersOrderIdGetPath = '/api/order/orders/{orderId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiOrderOrdersOrderIdGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiOrderOrdersOrderIdGet$Plain$Response(params: ApiOrderOrdersOrderIdGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Order>> {
    return apiOrderOrdersOrderIdGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiOrderOrdersOrderIdGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiOrderOrdersOrderIdGet$Plain(params: ApiOrderOrdersOrderIdGet$Plain$Params, context?: HttpContext): Observable<Order> {
    return this.apiOrderOrdersOrderIdGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Order>): Order => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiOrderOrdersOrderIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiOrderOrdersOrderIdGet$Response(params: ApiOrderOrdersOrderIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Order>> {
    return apiOrderOrdersOrderIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiOrderOrdersOrderIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiOrderOrdersOrderIdGet(params: ApiOrderOrdersOrderIdGet$Params, context?: HttpContext): Observable<Order> {
    return this.apiOrderOrdersOrderIdGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Order>): Order => r.body)
    );
  }

  /** Path part for operation `apiOrderOrdersOrderIdCheckstatusPut()` */
  static readonly ApiOrderOrdersOrderIdCheckstatusPutPath = '/api/order/orders/{orderId}/checkstatus';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiOrderOrdersOrderIdCheckstatusPut$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiOrderOrdersOrderIdCheckstatusPut$Plain$Response(params: ApiOrderOrdersOrderIdCheckstatusPut$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Response>> {
    return apiOrderOrdersOrderIdCheckstatusPut$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiOrderOrdersOrderIdCheckstatusPut$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiOrderOrdersOrderIdCheckstatusPut$Plain(params: ApiOrderOrdersOrderIdCheckstatusPut$Plain$Params, context?: HttpContext): Observable<Response> {
    return this.apiOrderOrdersOrderIdCheckstatusPut$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Response>): Response => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiOrderOrdersOrderIdCheckstatusPut()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiOrderOrdersOrderIdCheckstatusPut$Response(params: ApiOrderOrdersOrderIdCheckstatusPut$Params, context?: HttpContext): Observable<StrictHttpResponse<Response>> {
    return apiOrderOrdersOrderIdCheckstatusPut(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiOrderOrdersOrderIdCheckstatusPut$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiOrderOrdersOrderIdCheckstatusPut(params: ApiOrderOrdersOrderIdCheckstatusPut$Params, context?: HttpContext): Observable<Response> {
    return this.apiOrderOrdersOrderIdCheckstatusPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<Response>): Response => r.body)
    );
  }

  /** Path part for operation `apiOrderOrdersGet()` */
  static readonly ApiOrderOrdersGetPath = '/api/order/orders';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiOrderOrdersGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiOrderOrdersGet$Plain$Response(params?: ApiOrderOrdersGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Order>>> {
    return apiOrderOrdersGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiOrderOrdersGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiOrderOrdersGet$Plain(params?: ApiOrderOrdersGet$Plain$Params, context?: HttpContext): Observable<Array<Order>> {
    return this.apiOrderOrdersGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Order>>): Array<Order> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiOrderOrdersGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiOrderOrdersGet$Response(params?: ApiOrderOrdersGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Order>>> {
    return apiOrderOrdersGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiOrderOrdersGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiOrderOrdersGet(params?: ApiOrderOrdersGet$Params, context?: HttpContext): Observable<Array<Order>> {
    return this.apiOrderOrdersGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Order>>): Array<Order> => r.body)
    );
  }

}
